import 'css-chunksrc/client/scenes/task/allocations/allocation/spentHours/styles.scss';export default {
  "spentHours": "_spentHours_1d9ea_1",
  "input": "_input_1d9ea_7",
  "text": "_text_1d9ea_28"
};